import { styled } from 'styled-components';
export const DropdownWrapper = styled.div.withConfig({
  componentId: "aui__sc-pghfwk-0"
})(["display:flex;flex-direction:column;width:100%;"]);